import { useEffect } from 'react';

type Props = {
  show?: boolean;
};

let globalHideTimestamp = 0;

export function useHideDocumentScroll({ show }: Props = {}) {
  useEffect(() => {
    if (show) return undefined;

    const timestamp = new Date().getTime();
    globalHideTimestamp = timestamp;
    window.document.body.style.overflowY = 'hidden';

    return () => {
      if (globalHideTimestamp !== timestamp) return;
      window.document.body.style.overflowY = '';
    };
  }, [show]);
}
